import axios, { AxiosError } from "axios";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { INotification } from "@/services/interfaces";

@Module({
  name: "notifications",
  namespaced: true,
})
export default class Notifications extends VuexModule {
  count: number = 0;
  lastNotification: INotification | null = null;
  notifications: INotification[] = [];

  get getCount() {
    return this.count;
  }

  get getLastNotification() {
    return this.lastNotification;
  }

  get getNotifications() {
    return this.notifications;
  }

  @Mutation
  setCount(count: number) {
    this.count = count;
  }

  @Mutation
  setLastNotification(lastNotification: INotification) {
    this.lastNotification = lastNotification;
  }

  @Mutation
  setNotifications(notifications: INotification[]) {
    this.notifications = notifications;
  }

  @Action
  async requestCount(): Promise<void> {
    try {
      const res = await axios({
        method: "GET",
        url: "/api/notifications/count",
      });
      if (res.data?.data) {
        this.setCount(res.data?.data.count);
        this.setLastNotification(res.data?.data.lastNotification);
      }
    } catch (err) {
      const Error = err as AxiosError;
      console.warn(Error.message);
    }
  }

  @Action
  async requestNotifications(): Promise<void> {
    try {
      const res = await axios({
        method: "GET",
        url: "/api/notifications",
      });
      if (res.data?.data) this.setNotifications(res.data?.data.notifications);
    } catch (err) {
      const Error = err as AxiosError;
      console.warn(Error.message);
    }
  }
}
